<template>
  <div class="chartWidget__chartWrapper" ref="chartWrapper">
    <PieChart
      v-if="chartType === 'pie' && loaded"
      :chart-data="chartData"
      :options="options"
    />
    <!-- <BarChart :chart-data="chartData" :options="optionsByBar" v-if="chartType === 'bar'"/>
    <LineChart :chart-data="chartData" :options="optionsByLine" v-if="chartType === 'line'"/>
    <DonutChart :chart-data="chartData" :options="optionsByDonut" v-if="chartType === 'donut'"/>
    <StackedBarChart
      :chart-data="chartData"
      :options="optionsByStacked"
      v-if="chartType === 'stacked'"
    />-->
    <MultipleChart
      v-if="chartType === 'multiple' && loaded"
      :options="optionsByBars"
      :chart-data="chartData"
    />
    <BarChart
      v-if="chartType === 'bar' && loaded"
      :chart-data="chartData"
      :options="optionsByBars"
    />
  </div>
</template>

<script>

import PieChart from "./pie.js";
import BarChart from "./bar.js";
import DonutChart from "./donut.js";
import LineChart from "./line.js";
import StackedBarChart from "./stackedBar";
import MultipleChart from "./multiple";
import randomColor from "randomcolor";
import { setTimeout } from 'timers';


export default {
  components: { MultipleChart, BarChart, PieChart },
  name : 'ChartOnly',
  props: {
    chartType: {
      type: String,
      default: ""
    },
    chartData : {
      type : Object,
      default :() => {}
    },
    noLegend: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      key : 1,
      optionsByBars: "",
      legend: {
        display: true,
        fullWidth: true,
        position: "bottom",
        labels: {
          fontColor: "#8898aa",
          usePointStyle: true,
          padding: 15
        }
      },
      yAxes: {
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: "#dee2e6",
          drawBorder: false,
          drawTicks: false,
          lineWidth: 0.2,
          zeroLineWidth: 0.2,
          zeroLineColor: "#dee2e6",
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2]
        },
        ticks: {
          fontColor: "#8898aa",
          beginAtZero: true,
          padding: 10,
          callback: function(value) {
            if (!(value % 10)) {
              return '$' + numeral(value).format('0,00');
            }
          }
        }
      },
      xAxes: {
        gridLines: {
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false
        },
        ticks: {
          autoSkip: false,
          fontColor: "#8898aa",
          padding: 20
        },
        barPercentage: 0.7,
        maxBarThickness: 15
      },
      options : {}
    };
  },
  watch: {
    noLegend() {
      this.legend.display = !this.noLegend
    }
  },
  methods: {
    fillData() {
      this.optionsByBars = {
        responsive: true,
        scales: {
          yAxes: [this.yAxes],
          xAxes: [this.xAxes]
        },
        plugins: {
          datalabels: {
            display: false,
            align: "center",
            anchor: "center",
            font: { weight: "bold" }
          }
        },
        legend: this.legend,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label
              return `${label} : ${numeral(tooltipItem.value).format('0,00')}$`;
            }
          }}
      };

      this.options = {
        tooltips : {
          callbacks : {
            label : function(tooltipItem, data) {
              var indice = tooltipItem.index;
              return  data.labels[indice] +' : '+ numeral(data.datasets[0].data[indice]).format('0,00') + '$';
            }
          }
        },
        scales : {
          yAxes: [
            { display: false }
          ],
          xAxes: [
            { display: false }
          ]
        },
        plugins: {
          datalabels: {
            display: false,
            align: "center",
            anchor: "center",
            font: { weight: "bold" }
          }
        },
        legend : {
          display: true,
          fullWidth: false,
          position: "bottom",
          labels: {
            fontColor: "#8898aa",
            usePointStyle: true,
            padding: 10
          }
        }
      }
    }
  },
  created() {
    this.legend.display = !this.noLegend
    this.fillData()
  },
  mounted () {
    this.loaded = true
  },
};
</script>

<style lang="scss" scoped>
.chartWidget__chartWrapper {
  width: 100%;
}
</style>
